<template>
  <div>
    <ICountUp
        :delay="delay"
        :endVal="endValue"
        :options="options"
        @ready="onReady"
    />{{add}}
  </div>
</template>

<script type="text/babel">
import ICountUp from 'vue-countup-v2';
export default {
  name: 'demo',
  components: {
    ICountUp
  },
  props:{
    endValue: {
      type: Number,
      default: null
    },
    add: {
      type: String,
      default: null
    },
    seperator: {
      type: String,
      default: '.'
    },
    decimal: {
      type: String,
      default: ','
    },
    duration: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      delay: 0,
      endVal: this.endValue,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: this.seperator,
        decimal: this.decimal,
        prefix: '',
        suffix: '',
        duration: this.duration,
      }
    };
  },
  methods: {
    onReady: function(instance, CountUp) {
      const that = this;
     // instance.update(that.endVal + 100);
    }
  }
};
</script>

<style scoped>
</style>